import { useState } from 'react';
import Table from '../../../../../../component/table/Table';
import ArrowUp from '../../../../../../assets/image/arrow_up.svg';
import ArrowDown from '../../../../../../assets/image/arrowD.svg';
import { useNavigate } from 'react-router-dom';
import {
	creditNoteAppliedColumn,
	creditNoteColumn,
	paymentReceivedColumn,
	salesReturnColumn,
} from '../../../../components/tableColumns';
import './index.scss';
const InvoiceTableTabs = ({
	paymentsReceiveList,
	salesReturnList,
	creditNoteList,
	CreditNoteApplied,
}) => {
	const [isIndexTableTab, setIsNameTableTab] = useState(0);
	const [isShowTableTab, setIsShowTableTab] = useState(false);
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	return (
		<div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					backgroundColor: '#F6F6F9',
				}}
			>
				<div className="tabs">
					<div
						className={`tab invoice-table-tabs ${isIndexTableTab === 0 ? 'active' : 'inactive'}`}
						onClick={() => {
							setIsNameTableTab(0);
							setIsShowTableTab(true);
						}}
						
					>
						Payment Recieved
						<span
							style={{
								borderRadius: '5px',
								color: '#3B58FF',
								marginLeft: '7px',
							}}
						>
							{paymentsReceiveList.length ?? 0}
						</span>
					</div>
					<div
						className={`tab invoice-table-tabs ${isIndexTableTab === 1 ? 'active' : 'inactive'}`}
						onClick={() => {
							setIsNameTableTab(1);
							setIsShowTableTab(true);
						}}
					>
						Sales Return
						<span
							style={{
								borderRadius: '5px',
								color: '#3B58FF',
								marginLeft: '7px',
							}}
						>
							{salesReturnList.length ?? 0}
						</span>
					</div>
					<div
						className={`tab invoice-table-tabs ${isIndexTableTab === 2 ? 'active' : 'inactive'}`}
						onClick={() => {
							setIsNameTableTab(2);
							setIsShowTableTab(true);
						}}
					>
						Credit Note
						<span
							style={{
								borderRadius: '5px',
								color: '#3B58FF',
								marginLeft: '7px',
							}}
						>
							{creditNoteList.length ?? 0}
						</span>
					</div>
					<div
						className={`tab invoice-table-tabs ${isIndexTableTab === 3 ? 'active' : 'inactive'}`}
						onClick={() => {
							setIsNameTableTab(3);
							setIsShowTableTab(true);
						}}
					>
						Credit Note Applied
						<span
							style={{
								borderRadius: '5px',
								color: '#3B58FF',
								marginLeft: '7px',
							}}
						>
							{CreditNoteApplied.length ?? 0}
						</span>
					</div>
				</div>
				<div
					style={{
						padding: '0px 10px',
					}}
				>
					{isShowTableTab ? (
						<img
							style={{
								cursor: 'pointer',
							}}
							alt="Arrow_up"
							src={ArrowUp}
							onClick={() => setIsShowTableTab(false)}
						/>
					) : (
						<img
							style={{
								cursor: 'pointer',
							}}
							alt="Arrow_down"
							src={ArrowDown}
							onClick={() => setIsShowTableTab(true)}
						/>
					)}
				</div>
			</div>

			{isShowTableTab && isIndexTableTab === 0 && (
				<div className="table">
					<Table
						coloum={paymentReceivedColumn}
						row={paymentsReceiveList}
						onRowClick={(id) => {
							if (id) {
								navigate(`/user/${suburl}/payments-received-details/${id}`);
							}
						}}
						style={{ height: '210px', padding: '0%' }}
					/>
				</div>
			)}
			{isShowTableTab && isIndexTableTab === 1 && (
				<div className="table">
					<Table
						coloum={salesReturnColumn}
						row={salesReturnList}
						onRowClick={(id) => {
							navigate(`/user/${suburl}/sales-return-details/${id}`);
						}}
						style={{ height: '210px', padding: '0%' }}
					/>
				</div>
			)}
			{isShowTableTab && isIndexTableTab === 2 && (
				<div className="table">
					<Table
						coloum={creditNoteColumn}
						row={creditNoteList}
						onRowClick={(rowId) => {
							navigate(`/user/${suburl}/sales/credit-note-details/${rowId}`);
						}}
						style={{ height: '210px', padding: '0%' }}
					/>
				</div>
			)}
			{isShowTableTab && isIndexTableTab === 3 && (
				<div className="table">
					<Table
						coloum={creditNoteAppliedColumn}
						row={CreditNoteApplied}
						onRowClick={(rowId) => {
							navigate(`/user/${suburl}/sales/credit-note-details/${rowId}`);
						}}
						style={{ height: '210px', padding: '0%' }}
					/>
				</div>
			)}
		</div>
	);
};
export default InvoiceTableTabs;
